// extracted by mini-css-extract-plugin
module.exports = {"root":"NameEditor_root__biLD0","editor":"NameEditor_editor__3NCOc","dirtyDot":"NameEditor_dirtyDot__ZwD1W"};